import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { actionTypes } from "./employeeActionTypes";
import { UPDATE_PAGING } from "../../common/pagination/paginationActionTypes";
import * as customFn from "../../Global/CustomFunctions";
import FileDownload from "react-file-download";
import { LocalStorage } from "../../Global";
import { Common } from "../../../utils";

const { REST_API } = config;
const { Employee } = config.REST_API;
export const showEmployeeDetailView = () => {
  return { type: actionTypes.SHOW_EMPLOYEE_DETAILS };
};

export const add = () => {
  return { type: actionTypes.ADD_BTN };
};
export const clearEmpData = () => {
  return { type: actionTypes.CLEAR_EMP_DATA };
};
export const clearEmployeeFields = () => {
  return { type: actionTypes.CLEAR_EMPLOYEE_FIELDS };
};
export const addEmployeeView = (isEdit) => {
  return { type: actionTypes.ADD_BTN_EMPLOYEE, isEdit };
};
export const employeeBulkUpload = () => {
  return {
    type: actionTypes.BULK_UPLOAD,
  };
};
export const isValidPersonalInfo = (isValid) => {
  return { type: actionTypes.IS_VALID_FORM, isValid };
};

export const setErrors = (type, objErrors) => {
  return { type: type, objErrors };
};

export const editEmployeeDetails = (isEdit) => {
  return { type: actionTypes.EDIT_EMPLOYEE_DETAILS, isEdit };
};

export const setList = (type, data) => {
  return { type: type, data };
};
export const showEmployeesList = () => {
  return { type: actionTypes.CANCEL_BTN_EMPLOYEE };
};
export const cancel = () => {
  return { type: actionTypes.CANCEL_BTN };
};
export const setEmpId = (id) => {
  return { type: actionTypes.SET_EMPLOYEE_ID, id };
};
export const setEduArray = (data) => {
  return { type: actionTypes.SET_EDUCAITON_LIST, data };
};
export const setSkillArray = (data) => {
  return { type: actionTypes.SET_SKILL_LIST, data };
};
export const setWorkHistoryArray = (data) => {
  return { type: actionTypes.SET_WORK_HISTORY_LIST, data };
};
export const setFamilyDetailArray = (data) => {
  return { type: actionTypes.SET_FAMILY_LIST, data };
};
export const delEduArr = (DegreeName) => {
  return { type: actionTypes.DELETE_EDUCATION_ARRAY, DegreeName };
};
export const delFamilyArr = (Id) => {
  return { type: actionTypes.DELETE_FAMILY_ARRAY, Id };
};
export const delSkillArr = (Id) => {
  return { type: actionTypes.DELETE_SKILL_ARRAY, Id };
};
export const delWorkArr = (Id) => {
  return { type: actionTypes.DELETE_WORK_ARRAY, Id };
};
export const changePersonalInfo = () => {
  return { type: actionTypes.CHECK_PERSONAL_INFO_CHANGE };
};
export const changeContactInfo = () => {
  return { type: actionTypes.CHECK_CONTACT_INFO_CHANGE };
};
export const changeEducationInfo = () => {
  return { type: actionTypes.CHECK_EDUCATION_INFO_CHANGE };
};
export const changeFamilyInfo = () => {
  return { type: actionTypes.CHECK_FAMILY_INFO_CHANGE };
};
export const changeSkillInfo = () => {
  return { type: actionTypes.CHECK_SKILL_INFO_CHANGE };
};
export const changeWorkHistory = () => {
  return { type: actionTypes.CHECK_WORK_HISTORY_CHANGE };
};
export const clearChangeWirzad = () => {
  return { type: actionTypes.CLEAR_CHANGE_WIZARD };
};
export const loadingShow = () => {
  return { type: actionTypes.LOADING_SHOW };
};
export const loadingHide = () => {
  return { type: actionTypes.LOADING_HIDE };
};
export const clearEducationError = () => {
  return { type: actionTypes.CLEAR_EDUCATION_ERROR };
};
export const clearFamilyError = () => {
  return { type: actionTypes.CLEAR_FAMILY_ERROR };
};
export const clearSkillError = () => {
  return { type: actionTypes.CLEAR_SKILL_ERROR };
};
export const clearWorkHistoryError = () => {
  return { type: actionTypes.CLEAR_WORK_HISTORY_ERROR };
};
export const clearErrorObj = () => {
  return { type: actionTypes.CLEAR_ERROR_OBJECT };
};
export const setFileDetail = (file) => {
  return { type: actionTypes.SET_FILE_DETAIL, file };
};
export const clearFileDetail = () => {
  return { type: actionTypes.CLEAR_FILE_DETAIL };
};
export const clearEmployeeDetails = () => {
  return { type: actionTypes.CLEAR_EMPLOYEE_DETAILS };
};
export const profileImageSaveBtn = (value) => {
  return { type: actionTypes.PROFILE_IMAGE_SAVE_BTN, value };
};

export const changeEmployeeDetail = () => {
  return { type: actionTypes.CHECK_EMP_DETAIL_CHANGE };
};

export const saveEmpImage = (EmpId, ImageUrl) => {
  return (dispatch) => {
    let Url =
      REST_API.Employee.SaveImage +
      "?ImageURL=" +
      ImageUrl +
      "&" +
      "employeeId=" +
      EmpId;

    return axiosBasic
      .get(Url)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  };
};

export const setEployeeObjects = (employee) => {
  const ImageUrl = employee.ImageURL;
  const objPersonalInfo = {
    ImageURL: employee.ImageURL,
    Id: employee.Id,
    FirstName: employee.FirstName,
    LastName: employee.LastName,
    Gender: employee.Gender,
    Desigination: employee.Desigination,
    MaritalStatus: employee.MaritalStatus,
    Email: employee.Email,
    DOB: employee.DOB,
    DepartmentId: employee.DepartmentId,
    DepartmentName: employee.DepartmentName,
    Title: employee.Title,
    FullName: `${employee.FirstName} ${employee.LastName}`,
    NationalInsuranceNumber: employee.NationalInsuranceNumber,
    City: employee.City,
    PostalCode: employee.PostalCode,
    StudentLoan: employee.StudentLoan ? "Yes" : "No",
    StudentLoanPlan: employee.StudentLoanPlan,
    PermanentAddress: employee.PermanentAddress,
    ResidentialAddress: employee.ResidentialAddress,
    Country: employee.Country,
    PhoneNumber: employee.PhoneNumber,
  };
  const objEmployeeDetail = {
    Level: employee.Level,
    EmployeeStatus: employee.EmployeeStatus,
    HoursPerWeek: employee.HoursPerWeek,
    CNIC: employee.CNIC,
    Desigination: employee.Desigination,
    DepartmentId: employee.DepartmentId,
    JoiningDate: employee.JoiningDate,
    EmploymentConfirmationDate: employee.EmploymentConfirmationDate,
    EmployeeCode: employee.EmployeeCode,
  };
  const objOtherInfo = {
    Id: employee.Id,
    NTN: employee.NTN,
    EOBI: employee.EOBI,
    PassportNumber: employee.PassportNumber,
    BloodGroup: employee.BloodGroup,
    DisabilityDescription: employee.DisabilityDescription,
    Disability: employee.Disability,
    FamilyOPD: employee.FamilyOPD,
    WeddingLeaves: employee.WeddingLeaves,
    MedicalInsurance: employee.MedicalInsurance,
    LeaveEncashment: employee.LeaveEncashment,
  };

  const objContactInfo = {
    EmployeeId: employee.id,
    PhoneNumber: employee.PhoneNumber,
    MobileNo: employee.MobileNo,
    EmergencyContactName: employee.EmergencyContactName,
    EmergencyContactNumber: employee.EmergencyContactNumber,
  };
  const objEducationArray = employee.EmployeeEducations;
  const objFamilyArray = employee.EmployeeFamilies;
  const objSkillArray = employee.EmployeeSkills;
  const objWorkHistoryArray = employee.EmployeeWorkHistories;
  return {
    type: actionTypes.SET_EMPLOYEE_DETAILS,
    payload: {
      ImageUrl: ImageUrl,
      personalInfo: objPersonalInfo,
      employeeDetail: objEmployeeDetail,
      contactInfo: objContactInfo,
      otherInfo: objOtherInfo,
      educationArray: objEducationArray,
      familyArray: objFamilyArray,
      skillArray: objSkillArray,
      workHistoryArray: objWorkHistoryArray,
      empId: employee.Id,
    },
  };
};
export const getEmployeeDetails = (id) => {
  let newUrl = REST_API.Employee.GetSingleEmployee + id;

  return (dispatch) => {
    dispatch({ type: actionTypes.LOADING_SHOW });
    return axiosBasic
      .get(newUrl)
      .then((response) => {
        dispatch({ type: actionTypes.LOADING_HIDE });
        if (response.data != null) {
          //  dispatch(clearEmployeeDetails());
          dispatch(setEployeeObjects(response.data.data));
          return response;
        }
      })
      .catch((error) => {
        dispatch({ type: actionTypes.LOADING_HIDE });
        return error;
      });
  };
};
const getEmployeesList = (url, options) => {
  let newUrl =
    url +
    "?" +
    "officeId=" +
    options.officeId +
    "&" +
    "start=" +
    options.start +
    "&page=" +
    options.page +
    "&take=" +
    options.limit +
    "&isActive=" +
    options.isActive;
  return axiosBasic
    .get(newUrl)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      Common.showErrorMessage(error);
    });
};

export const employeesListing = (options, currentPage) => {
  return (dispatch) => {
    getEmployeesList(Employee.GetEmployees, options)
      .then((response) => {
        if (response.data != null) {
          dispatch({
            type: UPDATE_PAGING,
            payload: {
              data: {
                total: response.data.total,
                currentPage,
                pageLimit: options.limit,
              },
              response: response.data,
            },
          });
          dispatch({
            type: actionTypes.SHOW_EMPLOYEE_LIST,
            payload: response.data,
          });
        }
      })
      .catch(function (error) {
        Common.showErrorMessage(error);
      });
  };
};

export const savePersonalInfo = (employee, id) => {
  let officeId = customFn.getSelectedOffice();
  const obj = {
    Id: id,
    ImageURL: employee.ImageURL,
    FirstName: employee.FullName.split(" ")[0],
    LastName: employee.FullName.split(" ")[1],
    FullName: employee.FullName,
    Gender: employee.Gender,
    MaritalStatus: employee.MaritalStatus,
    Email: employee.Email,
    DOB: employee.DOB,
    officeId: officeId.Id,
    Title: employee.Title,
    NationalInsuranceNumber: employee.NationalInsuranceNumber,
    City: employee.City,
    Country: employee.Country,
    PostalCode: employee.PostalCode,
    StudentLoan: employee.StudentLoan.includes("Yes") ? true : false,
    StudentLoanPlan: employee.StudentLoanPlan,
    PermanentAddress: employee.PermanentAddress,
    ResidentialAddress: employee.ResidentialAddress,
    PhoneNumber: employee.PhoneNumber,
  };
  if (obj.TotalExperience === "") {
    obj.TotalExperience = 0;
  }
  return (dispatch) => {
    return axiosBasic
      .post(REST_API.Employee.Create, obj)
      .then((response) => {
        if (response.data.data != null) {
          let obj = { Id: response.data.data.Id, Add: "True" };
          localStorage.setItem(
            LocalStorage.currentEmployee,
            JSON.stringify(obj)
          );
          dispatch(setEmpId(response.data.data.Id));
        }
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  };
};
export const saveEmployeeDetail = (employee, id) => {
  const obj = {
    Level: employee.Level,
    EmployeeStatus: employee.EmployeeStatus,
    HoursPerWeek: employee.HoursPerWeek,
    CNIC: employee.CNIC,
    Desigination: employee.Desigination,
    DepartmentId: employee.DepartmentId,
    JoiningDate: employee.JoiningDate,
    EmploymentConfirmationDate: employee.EmploymentConfirmationDate,
    EmployeeCode: employee.EmployeeCode,
    EmployeeId: id,
  };
  return (dispatch) => {
    return axiosBasic
      .post(REST_API.Employee.EmployeeDetail, obj)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  };
};
export const saveOtherInfo = (employee, id) => {
  const obj = {
    Id: id,
    CNIC: employee.CNIC,
    NTN: employee.NTN,
    EOBI: employee.EOBI,
    PassportNumber: employee.PassportNumber,
    BloodGroup: employee.BloodGroup,
    DisabilityDescription: employee.DisabilityDescription,
    Disability: employee.Disability,
    FamilyOPD: employee.FamilyOPD,
    WeddingLeaves: employee.WeddingLeaves,
    MedicalInsurance: employee.MedicalInsurance,
    LeaveEncashment: employee.LeaveEncashment,
  };
  return (dispatch) => {
    return axiosBasic
      .post(REST_API.Employee.OtherInfo, obj)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  };
};

export const saveContactInfo = (contactInfo, id) => {
  const obj = {
    EmployeeId: id,
    PhoneNumber: contactInfo.PhoneNumber,
    MobileNo: contactInfo.MobileNo,
    EmergencyContactName: contactInfo.EmergencyContactName,
    EmergencyContactNumber: contactInfo.EmergencyContactNumber,
  };
  return (dispatch) => {
    return axiosBasic
      .post(REST_API.Employee.ContactInfo, obj)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  };
};
export const saveRange = (url, DataArray) => {
  let obj = {};
  obj.Range = DataArray;
  return (dispatch) => {
    return axiosBasic
      .post(url, obj)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  };
};

export const delRow = (url, id) => {
  return (dispatch) => {
    return axiosBasic
      .delete(url + "?id=" + id)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  };
};
export const Delete = (id, options) => {
  return (dispatch) => {
    axiosBasic
      .delete(REST_API.Employee.Delete + "?id=" + id)
      .then((response) => {
        const baseModel = response.data;
        if (baseModel.success) {
          getEmployeesList(REST_API.Employee.GetEmployees, options)
            .then((response) => {
              if (response.data != null) {
                dispatch({
                  type: UPDATE_PAGING,
                  payload: {
                    data: {
                      total: response.data.total,
                      currentPage: options.page,
                      pageLimit: options.limit,
                    },
                    response: response.data,
                  },
                });
                dispatch({
                  type: actionTypes.SHOW_EMPLOYEE_LIST,
                  payload: response.data,
                });
              }
            })
            .catch(function (error) {
              Common.showErrorMessage(error);
            });
        } else {
          dispatch({
            type: actionTypes.SHOW_ERROR,
            payload: baseModel.message,
            isShow: true,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.SHOW_ERROR,
          payload: "Oops, something went wrong.",
        });
      });
  };
};

export const DownloadTemplate = () => {
  return (dispatch) => {
    axiosBasic
      .get(REST_API.ImportExport.DownloadTemplate)
      .then((response) => {
        FileDownload(response.data, "Template.csv");
      })
      .catch(function (error) {
        Common.showErrorMessage(error);
      });
  };
};
export const UploadFile = (file) => {
  var formData = new FormData();
  formData.append("file", file);

  return (dispatch) => {
    axiosBasic
      .post(REST_API.ImportExport.UploadFile, formData, {
        headers: { "Content-Type": "application/octet-stream" },
      })
      .then((response) => {
        formData.delete("file");
        if (response.data.success) {
          Common.showSuccessMessage(response.data.message);
          dispatch({
            type: actionTypes.SHOW_BULK_SUCCESS,
            payload: "File Upload Successfully",
          });
          dispatch({
            type: actionTypes.LOADING_HIDE,
          });
        } else {
          Common.showErrorMessage(response.data.message);
          dispatch({
            type: actionTypes.SHOW_BULK_ERROR,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        Common.showErrorMessage(error);
      });
  };
};
